export const removeTags = function (s) {
  return s.replace(/<\/?[^>]+(>|$)/g, '');
};
